module.exports = __webpack_public_path__ + "img/height_armhole.6888c7bb.png";